import { NgModule } from '@angular/core';
import { SkyUiButtonModule } from './button/module';
import { SkyUiSpinnerModule } from './spinner/module';
import { SkyUiInputModule } from './input/module';
import { SkyUiTabsModule } from './tabs/module';
import { SkyUiTooltipModule } from './tooltip/module';
import { SkyUiNativeScrollModule } from './native-scroll/module';
import { SkyUiPopupModule } from './popup/module';
import { SkyUiIconModule } from './icon/module';
import { SkyUiSwitchModule } from './switch/module';
import { SkyUiCheckboxModule } from './checkbox/module';
import { SkyUiRadioModule } from './radio/module';
import { SkyUiSelectModule } from './select/module';
import { SkyUiPopoverModule } from './popover/module';
import { SkyUiProgressBarModule } from './progress-bar/module';

/**
 * @deprecated import individual modules instead
 */
@NgModule({
  exports: [
    SkyUiNativeScrollModule,
    SkyUiButtonModule,
    SkyUiSpinnerModule,
    SkyUiTabsModule,
    SkyUiInputModule,
    SkyUiTooltipModule,
    SkyUiPopupModule,
    SkyUiIconModule,
    SkyUiSwitchModule,
    SkyUiCheckboxModule,
    SkyUiRadioModule,
    SkyUiSelectModule,
    SkyUiPopoverModule,
    SkyUiProgressBarModule,
  ],
})
export class SkyUiModule {}
